module.exports = __webpack_public_path__ + "static/media/Jose-Luis-Martinez-Almeida_PP.cf5cc9af.png";